import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pictures",
  "use": "pictures-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"pictures\"><path d=\"M896 256v512c0 35.328-28.672 64-64 64H160c0 35.328 28.672 64 64 64h672c35.328 0 64-28.672 64-64V320c0-35.328-28.672-64-64-64zm-32 480V224c0-35.328-28.672-64-64-64H128c-35.328 0-64 28.672-64 64v512c0 35.328 28.672 64 64 64h672c35.328 0 64-28.672 64-64zM128 224h672v512H128V224zm372.064 329.952L404.448 452.16 308.8 615.488l-71.744-74.976-77.728 164.128h609.76L631.584 344.8l-131.52 209.152zM256 448c35.328 0 64-28.672 64-64s-28.672-64-64-64-64 28.672-64 64 28.672 64 64 64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pictures.svg
// module id = LIf4
// module chunks = 1